module.exports = __webpack_public_path__ + "static/media/hafið.722ff0f9.svg";